const mixNumber = (from, to, progress) => {
  return from + (to - from) * progress;
};
export {
  mixNumber
};
//# sourceMappingURL=number.js.map
